module.exports = __webpack_public_path__ + "static/media/face-greed.95ac26fd.webp";